import type { CollaborationNotesAdapter } from '~publish/components/CollaborationNotes'
import { insertCreatedNote } from '~publish/hooks/notes/notesCache'
import type { PostNoteSubject } from '~publish/hooks/notes/noteSubject'
import { useCreateNote } from '~publish/hooks/notes/useCreateNote'
import { useDeleteNote } from '~publish/hooks/notes/useDeleteNote'
import { useMarkNotesRead } from '~publish/hooks/notes/useMarkNotesRead'
import { useMarkNotesUnread } from '~publish/hooks/notes/useMarkNotesUnread'
import { useNotes } from '~publish/hooks/notes/useNotes'
import { useNotesReadState } from '~publish/hooks/notes/useNotesReadState'
import { useUpdateNote } from '~publish/hooks/notes/useUpdateNote'

/**
 * Post Notes through the Post operations (`collaborationNotes` with a
 * `postId`).
 */
export const postNotesAdapter: CollaborationNotesAdapter<PostNoteSubject> = {
  useNotes,
  useCreateNote,
  useUpdateNote,
  useDeleteNote,
  insertCreatedNote: (cache, subject, edge) =>
    insertCreatedNote(cache, subject, edge),
  // Post threads are already live: `LiveCollaborationNotes` mounts the
  // organization-wide `collaborationNotesChanges` stream once for the whole
  // session. A second stream here would apply every event twice.
  useSubscribe: () => undefined,
  useReadState: ({ subjectId }) => {
    const readState = useNotesReadState(subjectId)
    const markRead = useMarkNotesRead(subjectId, readState.apply)
    const markUnread = useMarkNotesUnread(subjectId, readState.apply)
    return { readState, markRead, markUnread }
  },
}
